import { useMemo } from 'react';

/**
 * Custom hook for country-related utilities.
 * Provides helper functions and transformed data for country dropdowns.
 *
 * @param {Array} countries - Array of country objects with {key, value} format
 * @returns {Object} Country utilities
 */
const useCountryUtils = (countries) => {
  // Transform countries for dropdown components
  const countryItems = useMemo(() => {
    if (!countries || !Array.isArray(countries)) return [];
    return countries.map(country => ({
      label: country.value,
      value: country.key
    }));
  }, [countries]);

  // Get country name from country code
  const getCountryName = (countryCode) => {
    if (!countryCode || !countries || !Array.isArray(countries)) {
      return countryCode || '';
    }
    const country = countries.find(c => c.key === countryCode);
    return country ? country.value : countryCode;
  };

  return {
    countryItems,
    getCountryName
  };
};

export default useCountryUtils;
